import React, { Component } from 'react';
import { getQuestionsFromData } from './DownloadCSV';
import { formValueSelector } from 'redux-form';
import {
  Document,
  PDFDownloadLink,
  StyleSheet,
  Text,
  View,
  Link,
} from '@react-pdf/renderer';
import styled from '@react-pdf/styled-components';
import { Button } from 'reactstrap';
import carePlanHeader from '../assets/img/kcc.png';
import finalPageHeader from '../assets/img/final-page-header.png';
import questions from './data';
import { searchByTwoKeys} from './simpleFunctions';

const Paragraph = styled.Text`
  margin: 10px;
  font-size: 12px;
  text-align: justify;
  font-family: "Times-Roman";
`;

const BodyText = styled.Text`
  margin-left: 12px;
  font-size: 12px;
  text-align: justify;
  font-family: "Times-Roman";
`;

const Footer = styled.Text`
  margin-left: 12px;
  font-size: 10px;
  text-align: justify;
  font-family: "Times-Roman";
  font-decoration: underline;
`;

const Header = styled.Image`
  width: 200,
  height: 200
`;

const FinalHeader = styled.Image`
  margin-vertical: 15;
  margin-horizontal: 15;
`;

const Title = styled.Text`
  margin: 12px;
  margin-top: 20px;
  font-weight: bold;
  font-size: 14px;
  font-family: "Times-Roman";
`;

const Intro = styled.Text`
  margin: 12px;
  margin-top: 30px;
  font-weight: bold;
  font-size: 14px;
  font-family: "Times-Roman";
  text-decoration: underline;
`;

const Body = styled.Page`
  padding-top: 40px;
  padding-bottom: 40px;
  padding-right: 40px;
  padding-left: 40px;
`;

const styles = StyleSheet.create({
  tableRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  tableColumn: {
    flexDirection: 'column',
    flex: 1,
    padding: 0,
  },
  table: {
    marginLeft: 70,
    marginTop: 10,
  },
  list: {
    marginLeft: 20,
  },
  centre: {
    textAlign: 'center',
    fontSize: 12,
    fontFamily: 'Times-Roman',
    margin: 20,
  },
  status: {
    marginLeft: 40,
    marginRight: 40,
  },
  underline: {
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  headerContainer: {
    flexDirection: 'row',
    height: 200,
  },
  headerText: {
    flex: 1,
    marginTop: 60,
    marginLeft: 30,
  },
});

const execSumm = {
  Name: 'A1',
  'Date of Birth': 'A3',
  MRN: 'A2',
  'Name of treating hospital': 'A11',
  'Primary diagnosis': 'A7',
  Oncologist: 'A9',
  'Age of diagnosis': 'A6',
  Treatment: 'A13',
};

class DownloadCarePlan extends Component {
  state = {
    merged: null,
  };
  componentWillMount() {
    const allQuestions = getQuestionsFromData(this.props.data);
    const answers = this.props.answers;
    const merged = {};
    allQuestions.forEach((element) => {
      answers.forEach((answer) => {
        if (element.id === answer.id) {
          if (answer.answers.length > 1) {
            merged[element.id] = [...answer.answers];
          } else merged[element.id] = answer.answers[0];
        }
      });
    });
    this.setState({ merged });
  }
  render() {
    const { merged } = this.state;
    const { recommendations, userDetails } = this.props;

    const patient = this.props.patient.patient.resource;
    const user = this.props.user;


    let contact1 = searchByTwoKeys('phone', 'work', user.telecom, 'system', 'use');
    if (contact1 === undefined) {
      contact1 = 'Not Defined';
    } else {
      contact1 = contact1.value;
    }

    let contact2 = searchByTwoKeys('phone', 'mobile', user.telecom, 'system', 'use');
    if (contact2 === undefined) {
      contact2 = 'Not Defined';
    } else {
      contact2 = contact2.value;
    }

    let contact3 = searchByTwoKeys('fax', 'work', user.telecom, 'system', 'use');
    if (contact3 === undefined) {
      contact3 = 'Not Defined';
    } else {
      contact3 = contact3.value;
    }

    let contact4 = searchByTwoKeys('email', 'work', user.telecom, 'system', 'use');
    if (contact4 === undefined) {
      contact4 = 'Not Defined';
    } else {
      contact4 = contact4.value;
    }

    // var contact4 = searchByTwoKeys("email", "work", user.telecom, "system", "use").value;
    const bmi = merged.K120 / (merged.K119 / 100) ^ 2;
    const CarePlan = (
      <Document>
        <Body wrap>
          <View style={styles.headerContainer}>
            <View style={styles.headerText}>
              <Text style={{ fontSize: 14 }}>{user.name[0].prefix} {user.name[0].given[0]} {user.name[0].family}</Text>
              <Text style={{ fontSize: 12 }}>{user.resourceType}</Text>
              <Text style={{ fontSize: 12 }}>Ph: {contact1}</Text>
              <Text style={{ fontSize: 12 }}>
                Ph (After Hours): {contact2}
              </Text>
              <Text style={{ fontSize: 12 }}>
                Fax: {contact3}
              </Text>
              <Text style={{ fontSize: 12 }}>
                Email: {contact4}
              </Text>

              {/* <Text style={{ fontSize: 14 }}>{userDetails["name"]}</Text>
              <Text style={{ fontSize: 12 }}>{userDetails["role"]}</Text>
              <Text style={{ fontSize: 12 }}>Ph: {userDetails["phone"]}</Text>
              <Text style={{ fontSize: 12 }}>
                Ph (After Hours): {userDetails["phoneAH"]}
              </Text>
              <Text style={{ fontSize: 12 }}>
                Fax: {userDetails["phoneAH"]}
              </Text>
              <Text style={{ fontSize: 12 }}>
                Email: {userDetails["email"]}
              </Text> */}
            </View>
            <View style={styles.headerImg}>
              <Header src={carePlanHeader} />
            </View>
          </View>
          <View style={styles.recipientContainer}>
            <BodyText>{patient.name[0].given[0]} {patient.name[0].family}</BodyText>
            {/* <BodyText>{recipientDetails["practice"]}</BodyText> */}
            <BodyText>{patient.address[0].line[0]}</BodyText>
            {patient.address[0].line.length > 1 ?
              <BodyText>{patient.address[0].line[1]}</BodyText>
              : null}
            <BodyText>{patient.address[0].city}</BodyText>
            <BodyText>
              {patient.address[0].state}, {patient.address[0].postalCode}
            </BodyText>
            {/* <BodyText>{recipientDetails["title"]}</BodyText>
            <BodyText>{recipientDetails["practice"]}</BodyText>
            <BodyText>{recipientDetails["street"]}</BodyText>
            <BodyText>{recipientDetails["city"]}</BodyText>
            <BodyText>
              {recipientDetails["state"]}, {recipientDetails["postcode"]}
            </BodyText> */}
          </View>
          <Paragraph>
            <Intro style={styles.underline}>
              Re: {`${merged.A1}      `} DOB: {`${merged.A3}      `} MRN:
              {`${merged.A2}      `}
            </Intro>
            <Intro style={styles.underline}>Diagnosis: {merged.A7}</Intro>
          </Paragraph>
          <Paragraph>
            <BodyText>
              We had the pleasure of reviewing your patient {`${merged.A1} `}
              as part of a new program we have recently introduced called
              ‘Re-engage’. More information about the program is enclosed. As a
              part of the Program, childhood cancer survivors who have become
              disengaged from cancer-focussed follow-up care are interviewed and
              the results of their comprehensive medical review are presented to
              a multidisciplinary team from the Survivorship Program at Sydney
              Children’s Hospital.
            </BodyText>
          </Paragraph>
          <Title>Executive Summary: </Title>
          <View style={styles.table}>{printExecSumm(merged)}</View>
          <Title>Recommendations for follow-up from MDT:</Title>
          <View style={styles.list}>
            <BodyText>{recommendations.followUp.resource.valueString}</BodyText>
          </View>
        </Body>
        <Body>
          <Paragraph>
            More detailed recommendations can be found at the end of this
            summary.
          </Paragraph>
          <Text style={styles.centre}>
            Recommendations for follow-up are based on Children’s oncology Group
            survivorship guidelines
            <Link>http://www.survivorshipguidelines.org/</Link>
          </Text>
          <Paragraph>Past Cancer history:</Paragraph>
          <Paragraph>{pastCancerHistory(merged)}</Paragraph>
          <Paragraph>
            Family history of cancer and relevant conditions:
          </Paragraph>
          <View style={styles.list}>
            {familyHistory(merged).map(answer => (
              <BodyText>{answer}</BodyText>
            ))}
          </View>
          <Paragraph>Current Status:</Paragraph>
          <View style={styles.status}>
            <View style={styles.tableRow}>
              <View style={styles.tableColumn}>
                <BodyText>Height: {merged.K119}cm</BodyText>
              </View>
              <View style={styles.tableColumn}>
                <BodyText>Weight: {merged.K120}kg</BodyText>
              </View>
              <View style={styles.tableColumn}>
                <BodyText>Waist: {merged.K121}cm</BodyText>
              </View>
              <View style={styles.tableColumn}>
                <BodyText>BMI: {bmi}</BodyText>
              </View>
            </View>
          </View>
          <Paragraph>Knowledge of Cancer History:</Paragraph>
          <View style={styles.list}>
            {knowledgeOfCancerHistory(merged).map(answer => (
              <BodyText>{answer}</BodyText>
            ))}
          </View>
          <Paragraph>Self-reported Health Status:</Paragraph>
          <View style={styles.list}>
            {healthStatus(merged).map(answer => (
              <BodyText>{answer}</BodyText>
            ))}
          </View>
        </Body>
        <Body>
          {lateEffectsSection(merged)}
          <Paragraph>
            Detailed recommendations from multidisciplinary team:
          </Paragraph>
          <View style={styles.list}>
            <BodyText>{recommendations.detailed.resource.valueString}</BodyText>
          </View>
          <Paragraph>Yours Sincerely,</Paragraph>
          <BodyText>{userDetails.name}</BodyText>
          <BodyText>{userDetails.role}</BodyText>
          <Footer style={styles.underline}>
            Cc: Prof Richard Cohn, Director Survivorship Program, Sydney
            Children’s Hospital;
          </Footer>
          <Footer style={styles.underline}>
            Dr Kate Webber, Adult Oncologist and Survivorship Physician
          </Footer>
        </Body>
        {finalPage()}
      </Document>
    );
    return (
      <PDFDownloadLink
        document={CarePlan}
        fileName={`${merged.A1}-CarePlan.pdf`}
      >
        <Button color="success" disabled={!merged.A1 && !recommendations.detailed.resource}>
          Download Care Plan
        </Button>
      </PDFDownloadLink>
    );
  }
}

export default DownloadCarePlan;

export const sortData = (props) => {
  const dataItem = props.data.item;
  const links = [];

  // loop through data to get the question id and push onto a new array called links
  dataItem.forEach((element) => {
    if (element.type === 'group') {
      const groupItem = element.item;
      groupItem.forEach((item) => {
        // let question = item.linkId;
        // question = [`Question ${item.linkId}`];
        const question = [`${element.linkId}${item.linkId}`];
        links.push(question);
      });
    }
  });

  // selector gets all the form values
  const selector = formValueSelector('DTT');
  const formAnswers = selector(props, ...links);

  // separate array to get the 'Question No.' of the answers
  const keys = Object.keys(formAnswers);

  const displays = [];

  // map the keys array which has the answers to be in the right format
  const answersWithQuestionId = keys.map((key) => {
    const answers = formAnswers[key];

    // check for array, object, string
    if (answers instanceof Array) {
      const NewArrayofAnswers = answers.map(element => element.display);
      const ArrayAnswer = { id: key, answers: NewArrayofAnswers };
      displays.push(ArrayAnswer);
    } else if (typeof answers === 'object') {
      const ObjectAnswer = { id: key, answers: [answers.display] };
      displays.push(ObjectAnswer);
    } else if (typeof answers === 'string') {
      const StringAnswer = { id: key, answers: [answers] };
      displays.push(StringAnswer);
    }
    return displays;
  });

  // create new array of unique answers only and flatten the final array of answers
  const RemovedDuplicates = [...new Set(answersWithQuestionId)];
  const FinalAnswers = RemovedDuplicates.reduce((a, b) => a.concat(b), []);
  return {
    answers: FinalAnswers,
  };
};

const printExecSumm = (merged) => {
  const toPrint = [];
  for (const key in execSumm) {
    toPrint.push(<View key={key} style={styles.tableRow}>
      <View style={styles.tableColumn}>
        <BodyText>{key}:</BodyText>
      </View>
      <View style={styles.tableColumn}>
        <BodyText>{merged[execSumm[key]]} </BodyText>
      </View>
    </View>);
  }
  return toPrint;
};

const pastCancerHistory = (merged) => {
  const toPrint = [];
  toPrint.push(<React.Fragment>
      To summarize, {merged.A1} was diagnosed with {merged.A7} at the age of{' '}
    {merged.A6}. They were treated with {merged.A13}. {`${merged.A1} `}
  </React.Fragment>);
  if (merged.D47) {
    if (merged.D47 === 'Yes') {
      if (merged.D48 === 'Yes') {
        toPrint.push(<React.Fragment>
            has had relapse and recieved additional therapy.
        </React.Fragment>);
      } else {
        toPrint.push(<React.Fragment>
            has had relapse and hasn't recieved additional therapy.
        </React.Fragment>);
      }
    } else toPrint.push(<React.Fragment>has not had relapse.</React.Fragment>);
  }
  toPrint.push(<React.Fragment> {` ${merged.A1} `}</React.Fragment>);
  if (merged.D49 === 'Yes') {
    if (merged.D50 === 'Yes') {
      toPrint.push(<React.Fragment>
          has been diagnosed with a secondary cancer and has received additional
          therapy
      </React.Fragment>);
    } else {
      toPrint.push(<React.Fragment>
          has been diagnosed with a secondary cancer and has NOT received
          additional therapy.
      </React.Fragment>);
    }
  } else {
    toPrint.push(<React.Fragment>
        has NOT been diagnosed with a secondary cancer and has NOT received
        additional therapy.
    </React.Fragment>);
  }

  return toPrint;
};

const familyHistory = (merged) => {
  const familyHistory = [];
  if (merged.E54 === 'No') {
    familyHistory.push('No relevant genetic conditions affecting family');
  } else if (merged.E55 === 'Yes') {
    familyHistory.push('Aware of genetic conditions affecting family');
  }
  if (merged.E56 === 'No') {
    familyHistory.push('No relatives diagnosed with cancer under the age of 70 years');
  } else if (merged.E57 === 'Yes') {
    familyHistory.push(`Does have relatives diagnosed with cancer under the age of 70 years: ${
      merged.E57}`);
  }
  familyHistory.push(merged.E58);
  return familyHistory;
};

const knowledgeOfCancerHistory = (merged) => {
  const answers = [];
  if (merged.B28 === 'Yes') {
    answers.push(`${merged.A1
    }'s parents passed on information about their cancer or treatement`);
  } else if (merged.B28 === 'No') {
    answers.push(`${merged.A1
    }'s parents did NOT pass on information about their cancer or treatement`);
  }
  if (merged.B33 === 'Yes') {
    answers.push('Did recieve a treatment summary/passport');
  } else if (merged.B33 === 'No') {
    answers.push('Did NOT recieve a treatment summary/passport');
  }
  if (merged.B29 === 'Yes') {
    answers.push(`Does remember when they were last seen at the hospital or long term follow-up clinic${
      merged.B30 === 'Yes'
        ? ' and was advised to return'
        : ' and was not advised to return'}`);
  } else if (merged.B29 === 'No') {
    answers.push('Does NOT remember when they were last seen at the hospital or long term follow-up clinic');
  }
  return answers;
};

const healthStatus = (merged) => {
  const answers = [];
  answers.push(`${merged.A1}'s overall health: ${merged.B35}`);
  if (merged.B36 === 'Yes') {
    answers.push('Has been to the GP for illnesses of concerns in the past 2 years');
  } else if (merged.B36 === 'No') {
    answers.push('Has NOT been to the GP for illnesses of concerns in the past 2 years');
  }
  if (merged.B38 === 'Yes') {
    answers.push('Is seeing another HCP for health issues');
  } else if (merged.B38 === 'No') {
    answers.push('Is NOT seeing another HCP for health issues');
  }
  answers.push(merged.B40);
  return answers;
};

const lateEffectsSection = (merged) => {
  let toPrint = [];
  questions.item.forEach((group, i) => {
    if (i > 6 && printAnswers(merged, group.linkId).length > 0) {
      toPrint.push(<Title>{group.text}</Title>);
      toPrint = [toPrint, ...printAnswers(merged, group.linkId)];
    }
  });
  return toPrint;
};

const printAnswers = (merged, linkId) => {
  const relevantResponses = [];
  for (const key in merged) {
    if (key.slice(0, 1) === linkId) {
      const question = questions.item
        .find(item => item.linkId === linkId)
        .item.find(item => item.linkId === key.slice(1)).text;
      if (!dontPrint.includes(merged[key]) || printIfNo.includes(key)) {
        relevantResponses.push(<React.Fragment>
          <View style={styles.tableRow}>
            <View style={styles.tableColumn}>
              <BodyText>{question}:</BodyText>
            </View>
            <View style={styles.tableColumn}>
              {typeof merged[key] === 'object' ? (
                merged[key].map((answer, i) => (
                  <BodyText>{`${answer},`}</BodyText>
                ))
              ) : (
                <BodyText>{merged[key]}</BodyText>
              )}
            </View>
          </View>
        </React.Fragment>);
      }
    }
  }
  return relevantResponses;
};

const finalPage = () => (
  <Body>
    <FinalHeader src={finalPageHeader} />
    <Title>Additional information about the Re-engage Program </Title>
    <Title>
      Why is long-term follow-up of childhood cancer survivors important?
    </Title>
    <Paragraph>
      Children and adolescents often tolerate acute cancer treatments well,
      however, the majority will experience life-altering, and some even life
      threatening conditions as a result of the cancer treatments they received.
      Many chronic conditions related to cancer treatment do not appear until
      years to decades after completion of treatment and research supports the
      need for continuing management through long-term follow-up care well into
      adult life. The survivorship clinic is designed to review patients who
      were diagnosed with a malignancy and/or received antineoplastic therapy in
      childhood or adolescence, and are now either 5 years from diagnosis or at
      least 2 years from completion of therapy. However, some patients do not
      return to clinic for various reasons and may not benefit from life-saving
      surveillance.
    </Paragraph>
    <Title> Who is Re-engage Program targeted for?</Title>
    <Paragraph>
      The Re-engage program is designed for long term survivors of childhood
      cancer who are not receiving any cancer-related follow-up care.
    </Paragraph>
    <Title> What does the Re-engage Program aim to achieve? </Title>
    <Paragraph>
      The Re-engage program aims to re-establish contact with survivors in a way
      that removes as many barriers as possible. Patients are required to fill
      in a questionnaire, and are then interviewed either by phone or Skype by a
      Clinical Nurse Consultant.
    </Paragraph>
    <Title>What does the Re-engage Program involve?</Title>
    <Paragraph>
      The results of patient interviews are presented to a multidisciplinary
      team from the Survivorship Program at Sydney Children’s Hospital,
      comprising of a paediatric and adult oncologist, a general practitioner,
      social worker, clinical psychologist and research psychologist. The
      recommendations are fed back to the survivor, and a report sent to the
      patient’s GP. Depending on their risk category, patient will be
      recommended to attend clinic if they require multi-disciplinary assessment
      and/or to make an appointment to see their GP.
    </Paragraph>
  </Body>
);

const dontPrint = [
  'No',
  'na',
  'n/a', // Not sure about this @ Neha
  'N/A',
  'n/A',
  'N/a',
  'NA',
  'Na',
  'nA',
  'Not Applicable',
  'Not applicable',
  "Don't Know",
];

const printIfNo = ['G74', 'G77', 'I97', 'J108', 'J115', 'S247'];



// WEBPACK FOOTER //
// ./src/components/DownloadCarePlan.js